import React, { Component } from "react"
import "./userAvatar.scss"
import styled from "@emotion/styled"
import { bindActionCreators } from "redux"
import { getData } from "../../library/store/actions/creators/authCreators"
import { connect } from "react-redux"
import avatarDefault from "../../assets/img/user_avatar.svg"
import unavailableAvatar from "../../assets/img/user_unavailable.svg"

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
  background-color: #fff;
`

class UserAvatar extends Component {

    state = {
        avatar: !this.props.auth.userData.deleted && !this.props.auth.userData.blocked ? this.props.auth.userData.photo : unavailableAvatar,
    };

    componentDidUpdate(prevProps) {
        if (
            this.props.auth.userData.photo !== prevProps.auth.userData.photo
            || this.props.auth.userData.deleted !== prevProps.auth.userData.deleted
            || this.props.auth.userData.blocked !== prevProps.auth.userData.blocked
        ) {
            this.setState({avatar: !this.props.auth.userData.deleted && !this.props.auth.userData.blocked ? this.props.auth.userData.photo : unavailableAvatar});
        }
    }

    render() {
        const {classes} = this.props;
        const {avatar} = this.state;

        const url = avatar !== "" ? avatar : avatarDefault;

        return (
            <div className={classes}>
                <Img src={url} alt="Avatar"/>
            </div>
        );
    }
}

const mapStateToProps = ({auth}) => ({auth});
const mapDispatchToProps = dispatch => bindActionCreators({getData}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserAvatar);
